// h.js — sicheres HTML aus Tagged Templates.
//   html`<p>${name}</p>`     → Werte werden IMMER escaped (XSS-sicher)
//   html`<ul>${items.map(i => html`<li>${i}</li>`)}</ul>`  → verschachtelte Templates/Arrays erlaubt
//   unsafeHtml(str)          → nur für vertrauenswürdiges, selbst erzeugtes Markup (z. B. SVG-Charts)
//   render(el, tpl)          → setzt den Inhalt eines Elements
// Events nicht inline binden, sondern per Delegation (dom.js `on`).

const SAFE = Symbol('vc-safe-html');

export function escHtml(v) {
  return String(v == null ? '' : v)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}

class SafeHtml {
  constructor(s) { this.s = s; this[SAFE] = true; }
  toString() { return this.s; }
}

export const unsafeHtml = (s) => new SafeHtml(String(s == null ? '' : s));

function part(v) {
  if (v == null || v === false || v === true) return '';
  if (v && v[SAFE]) return v.s;
  if (Array.isArray(v)) return v.map(part).join('');
  return escHtml(v);
}

// Steht ein Wert direkt in einem Attribut (`aria-pressed="${x}"`), werden true/false
// zu "true"/"false" — im Inhalt verschwinden sie (für `${cond && html`…`}`).
const IN_ATTR = /=["']$/;

export function html(strings, ...values) {
  let out = strings[0];
  for (let i = 0; i < values.length; i++) {
    const v = values[i];
    out += (typeof v === 'boolean' && IN_ATTR.test(strings[i]) ? String(v) : part(v)) + strings[i + 1];
  }
  return new SafeHtml(out);
}

/** Attribute aus einem Objekt: attrs({ disabled: true, 'aria-label': x }) → ' disabled aria-label="…"'. */
export function attrs(obj) {
  let s = '';
  for (const [k, v] of Object.entries(obj || {})) {
    if (v == null || v === false) continue;
    s += v === true ? ' ' + k : ' ' + k + '="' + escHtml(v) + '"';
  }
  return new SafeHtml(s);
}

/** Klassen bedingt zusammensetzen: cls('a', cond && 'b') */
export const cls = (...a) => a.filter(Boolean).join(' ');

export function render(el, tpl) {
  if (!el) return;
  el.innerHTML = tpl && tpl[SAFE] ? tpl.s : escHtml(tpl);
}

/** Template → DocumentFragment (für Einfügen ohne den Container zu ersetzen). */
export function frag(tpl) {
  const t = document.createElement('template');
  t.innerHTML = tpl && tpl[SAFE] ? tpl.s : escHtml(tpl);
  return t.content;
}
